module.exports = __webpack_public_path__ + "media/assets/images/sales-processes-finish-03f022b187012a9e277eff6da6487c0b.svg";